export default {
  namespaced: true,
  getters: {

  },
  actions: {
    resetCurrent: (context) => {
      context.commit('resetCurrent');
    },
  },
  mutations: {
    resetCurrent: () => {
    },
  }
}
